<!--
- 数据简报（手机端）
- author: wang.y
-->
<template>
  <div class="index">
    <div :class="{header: true, on: isOpen}" v-cloak>
      <img :src="$store.state.static_img_url + 'pic/newsletter/santen-logo.png'">
      <span @click="chapter_list_show = !chapter_list_show" v-if="chapter_params.chapter_id">第{{chapter_num(chapter_params.chapter_id)}}期 {{current_chapter_name}}<i class="iconfont"><template v-if="chapter_list_show">&#xe63b;</template><template v-else>&#xe648;</template></i></span>
    </div>
    <div class="chapter-sel">
      <ul v-if="chapter_list_show">
        <li v-for="item in chapter_list" :key="item.id" :class="{active: chapter_params.chapter_id == item.id}" @click="haddleChangeChapter(item.id,item.publish_time)">
          <i class="iconfont">&#xe628;</i>
          <span>第{{item.num}}期 {{item.title}}</span>
        </li>
      </ul>
    </div>
    <div class="chapter-meng" v-if="chapter_list_show" @click="chapter_list_show = !chapter_list_show"></div>
    <div :class="{plane: true, on: isOpen}">
      <div class="banner">
        <div class="tle">
          <p>{{custom_report_detail.title}}</p>
        </div>
        <img :src="$store.state.static_img_url + 'pic/newsletter/santen-bg-m.png'" />
      </div>
      <div class="content">
        <div class="numbers clear">
          <div v-for="item,index in chapter_module" :key="index" @click="haddleModelSlider(item.id)" :class="{'blue': item.id == '13'}">
            <span>{{item.name}}</span>
            <i class="iconfont number-icon">&#xe647;</i>
          </div>
        </div>
        <div class="summary">
          <p class="tle">本期摘要</p>
          <p class="tle-line"></p>
          <div v-html="chapter_detail.summary"></div>
        </div>
        <div class="temps">
          <div class="temp" v-for="item,index in chapter_module" :key="index" :id="'tempLi' + item.id">
            <div class="temp-content">
              <div class="tle">
                <img :src="$store.state.static_img_url + 'mobile/pic/briefReport/icon_l.png'">
                <span>{{item.name}}</span>
                <img :src="$store.state.static_img_url + 'mobile/pic/briefReport/icon_r.png'">
              </div>
              <div class="temp-tip" v-if="insight[item.id] && insight[item.id].length > 0">
                <i class="iconfont">&#xe654;</i>
                <div v-html="insight[item.id][0].text"></div>
              </div>
              <ul class="topic-list" v-if="module_list[item.id] && module_list[item.id]['topic'].length > 0">
                <li v-for="topicItem,topicIndex in module_list[item.id]['topic']" :key="topicIndex" v-show="topicIndex < 10 || show_all_list[item.id]">
                  <p class="topic-tle" @click="goTopicDetail(topicItem)"><img :src="$store.state.static_img_url + 'mobile/pic/briefReport/slash.png'" class="slash"><span v-html="topicItem.title"></span></p>
                  <p class="topic-dec" @click="goTopicDetail(topicItem)">{{topicItem.content}}</p>
                </li>
              </ul>
              <ul class="project-list" v-if="module_list[item.id] && module_list[item.id]['entity'].length > 0">
                <li v-for="entityItem,entityIndex in entity_list(module_list[item.id]['entity'])" :key="entityIndex" v-show="entityIndex < 10 || show_all_list[item.id]">
                  <div class="pro-title">{{entityItem.short_name}}</div>
                  <div class="pro-top">
                    <div class="pro-img">
                      <div>
                        <img :src="entityItem.logo_path | logo_show" />
                      </div>
                    </div>
                    <div class="pro-dec">
                      <p class="p1">最新轮次：{{entityItem.round_id | dealNeed(round)}}</p>
                      <p class="p2" v-if="entityItem.latest_event.event_time">融资时间：{{entityItem.latest_event.event_time | time_moment('YYYY-MM-DD')}}</p>
                    </div>
                  </div>
                  <div class="pro-btm">
                    <div class="pro-sm">
                      <div class="pro-l"><i class="iconfont">&#xe690;</i><template v-if="entityItem.type == 0">公司</template><template v-if="entityItem.type == 1">机构</template><template v-if="entityItem.type == 3">医院</template>简介</div>
                      <div class="pro-r">
                        <p>{{entityItem.summary | empty('暂无简介')}}</p>
                      </div>
                    </div>
                    <div class="pro-sm" v-for="entityItem2 in entityItem.temp" :key="entityItem2.id">
                      <div class="pro-l"><i class="iconfont">&#xe68e;</i>{{entityItem2.name}}</div>
                      <div class="pro-r">
                        <div class="tags">
                          <span class="tag" v-for="entityItem3,idx in entityItem2.arr" :key="idx">{{entityItem3.name}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <ul class="article-list" v-if="module_list[item.id] && module_list[item.id]['art'].length > 0">
                <li v-for="artItem,artIndex in module_list[item.id]['art']" :key="artIndex" v-show="artIndex < 10 || show_all_list[item.id]">
                  <a :href="$store.state.index2_path +'/'+ artItem.id">
                    <div class="article-img">
                      <span>文章</span>
                      <img :src="artItem.logo_path | logo_show" />
                    </div>
                    <div class="article-info">
                      <p class="p1" v-html="artItem.title"></p>
                      <p class="p2">
                        <span><i class="iconfont">&#xe645;</i>动脉网</span>
                        <span><i class="iconfont">&#xe632;</i>{{artItem.publish_time | time_moment}}</span>
                      </p>
                    </div>
                  </a>
                </li>
              </ul>
              <ul class="article-list" v-if="module_list[item.id] && module_list[item.id]['report'].length > 0">
                <li v-for="reportItem,reportIndex in module_list[item.id]['report']" :key="reportIndex" v-show="reportIndex < 10 || show_all_list[item.id]">
                  <a @click="handleOpenPdf(reportItem.file_path)">
                    <div class="article-img">
                      <span>报告</span>
                      <img :src="reportItem.logo_path | logo_show" />
                    </div>
                    <div class="article-info">
                      <p class="p1" v-html="reportItem.title"></p>
                      <p class="p2">
                        <span v-if="reportItem.src_author"><i class="iconfont">&#xe645;</i>来源：{{reportItem.src_author}}</span>
                      </p>
                    </div>
                  </a>
                </li>
              </ul>
              <div class="temp-bottom" v-if="module_list[item.id] && (module_list[item.id]['topic'].length > 10 || module_list[item.id]['entity'].length > 10 || module_list[item.id]['art'].length > 10 || module_list[item.id]['report'].length > 10)">
                <span class="more-btn" @click="showAllList(item.id)">
                  <template v-if="!show_all_list[item.id]">查看全部</template>
                  <template v-else>收起全部</template>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="return-btn" v-show="scroll_top > 360" @click="goBack">
        <i class="iconfont">&#xe63b;</i>
      </div>
    </div>
    <!-- <div class="loading2" v-if="loading">
      <div class="loading2_cnt">加载中<div class="loader-box"></div>
      </div>
    </div> -->
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import {
  getMeta,
  addPuv,
  customReportDetail,
  chapterDetail,
  chapterModuleContent,
  wxShare,
} from '../service'
import { share } from 'mobile/js/wx_share'
import filter from 'js/filter'
export default {
  data() {
    return {
      isOpen: false,

      loading: true,
      filter: filter,

      params: {
        uid: '307330e4c08c6869149fde728234af80',
      },
      current_chapter_name: '',
      chapter_params: {
        chapter_id: '',
        custom_report_id: '',
      },

      custom_report_detail: '',
      chapter_list: [],

      chapter_detail: '',
      chapter_module: [],

      module_list: {},
      insight: {},

      show_all_list: {},

      scroll_top: 0,

      chapter_list_show: false,

      dynview_tag: [],
      dynview_tag_type: [],
      round: [],
    }
  },
  computed: {
    protocol() {
      return window.location.protocol
    },
    user_key() {
      return this.$store.state.user_key
    },
    chapter_num() {
      return function (chapter_id) {
        let index = this.chapter_list.findIndex((a) => a.id == chapter_id)
        return this.chapter_list[index].num
      }
    },
    entity_list() {
      return function (list) {
        let arr = []
        var dt = this.dynview_tag
        var dtt = this.dynview_tag_type
        for (var a = 0; a < list.length; a++) {
          var temp = []
          for (var b = 0; b < list[a].tag.length; b++) {
            var c = this.handleTag(dt, dtt, list[a].tag[b])
            var d = this.handleFindTag(c.type.id, temp)
            if (d) {
              d.arr.push(c.tag)
            } else {
              temp.push({
                id: c.type.id,
                name: c.type.name,
                arr: [c.tag],
              })
            }
          }
          arr.push({
            description: list[a].description,
            full_name: list[a].full_name,
            id: list[a].id,
            latest_event: list[a].latest_event,
            logo_path: list[a].logo_path,
            round_id: list[a].round_id,
            short_name: list[a].short_name,
            summary: list[a].summary,
            tag: list[a].tag,
            uid: list[a].uid,
            type: list[a].type,
            temp: temp,
          })
        }
        return arr
      }
    },
    img_req_url() {
      return this.$store.state.img_req_url
    },
  },
  methods: {
    async getMeta() {
      let res = await getMeta(
        {
          name: ['dynview_tag', 'dynview_tag_type', 'round'],
        },
        (error) => this.$Message.error('请求错误！')
      )
      if (res.status == 'success') {
        this.dynview_tag = res.meta.dynview_tag
        this.dynview_tag_type = res.meta.dynview_tag_type
        this.round = res.meta.round
        this.getCustomReportDetail()
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getAddPuv() {
      let puv_params = {
        user_key: this.user_key,
        url: window.location.href,
        row_id: this.custom_report_detail.id,
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('请求错误！'))
    },
    /**
     * 获取简报和期刊信息
     */
    async getCustomReportDetail() {
      let res = await customReportDetail(this.params, (error) => this.$Message.error('请求错误！'))
      if (res.status == 'success') {
        this.$set(this.$data, 'custom_report_detail', res.res[0])
        this.$set(this.$data, 'chapter_list', res.chapter)
        this.chapter_params.chapter_id = this.chapter_list[0].id
        this.chapter_params.custom_report_id = this.custom_report_detail.id
        this.current_chapter_name = this.chapter_list[0].title
        this.getChapterDetail()
        this.getAddPuv()
      } else {
        this.$Message.error(res.message)
      }
    },
    async getChapterDetail() {
      let res = await chapterDetail(this.chapter_params, (error) =>
        this.$Message.error('请求错误！')
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'chapter_detail', res.res[0])
        this.$set(this.$data, 'chapter_module', res.module)
        this.themeShare()

        let promise_arr = []
        if(res.module.length) {
          res.module.map((a) => {
            promise_arr.push(new Promise((resolve) => this.getChapterModuleContent(a.id, resolve)))
            this.show_all_list[a.id] = false
          })
          Promise.all(promise_arr).then((data) => {
            this.loading = false
            this.$nextTick(() => {
              if(localStorage.viewer_re_top && localStorage.viewer_re) {
                $('html, body').animate({ scrollTop: localStorage.viewer_re_top }, 200)
                localStorage.removeItem('viewer_re_top')
                localStorage.removeItem('viewer_re')
              } else {
                localStorage.removeItem('viewer_re_top')
                localStorage.removeItem('viewer_re')
              }
            })
          })
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    async getChapterModuleContent(module_id, resolve) {
      let module_params = {
        chapter_id: this.chapter_params.chapter_id,
        module_id: module_id,
      }
      let res = await chapterModuleContent(module_params, (error) =>
        this.$Message.error('请求错误！')
      )
      if (resolve) resolve()
      if (res.status == 'success') {
        this.module_list[module_id] = res.content
        this.insight[module_id] = res.insight
        this.$forceUpdate()
      } else {
        this.$Message.error(res.message)
      }
    },
    handleTag(dt, dtt, id) {
      var own = this.handleFindTag(id, dt)
      var type
      if (own.pid == null && own.pgid == null) {
        type = this.handleFindTag(own.type_id, dtt)
      } else if (own.pid != null && own.pgid == null) {
        type = this.handleFindTag(this.handleFindTag(own.pid, dt).type_id, dtt)
      } else {
        type = this.handleFindTag(this.handleFindTag(own.pgid, dt).type_id, dtt)
      }
      return {
        type: type,
        tag: own,
      }
    },
    handleFindTag(id, arr) {
      for (var a = 0; a < arr.length; a++) {
        if (arr[a].id == id) {
          return arr[a]
          break
        }
      }
    },
    /**
     * 导航点击事件
     * item 点击的对象
     */
    haddleModelSlider(module_id) {
      let targetTop
      if (module_id !== '') {
        targetTop = $('#tempLi' + module_id).offset().top - 50 //滚动条目标位置
      } else {
        targetTop = 0
      }
      $('html, body').animate({ scrollTop: targetTop }, 200)
      // this.isOpen = !this.isOpen
    },
    /**
     * 监听滚动条改变
     * 导航高亮
     */
    haddleScroll() {
      this.scroll_top = document.documentElement.scrollTop || document.body.scrollTop //滚动条的值
    },
    showAllList(item_id) {
      this.show_all_list[item_id] = !this.show_all_list[item_id]
      this.$forceUpdate()
    },
    haddleChangeChapter(value, date) {
      this.chapter_params.chapter_id = value
      this.chapter_params.chapter_date = date
      this.chapter_list_show = !this.chapter_list_show
      $('html, body').animate({ scrollTop: 0 }, 200)
      this.getChapterDetail()
    },
    async getAddPuv() {
      let puv_params = {
        user_key: this.user_key,
        url: window.location.href,
        row_id: this.custom_report_detail.id,
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('请求错误！'))
    },
    async themeShare() {
      let lurl = this.$store.state.index_path + '/mindex' + this.$route.fullPath
      let summay = this.chapter_detail.summary ? this.chapter_detail.summary.replace(/<[^>]+>/g,'').slice(0, 50) : this.chapter_detail.title
      let desc = summay.length == 50 ? summay + '...' : summay
      let res = await wxShare(
        { url: lurl },
        (error) => {
          this.$Message.error('请求错误!')
        }
      )
      share(
        res,
        {
          title: this.chapter_detail.title + '-动脉橙',
          desc: desc,
          link: lurl,
          imgUrl: this.$store.state.img_req_url + this.custom_report_detail.logo_path
        },
        this,
        window.location.href
      )
    },
    goBack() {
      $('html, body').animate({ scrollTop: 0 }, 200)
    },
    handleOpenPdf(path) {
      localStorage.setItem('viewer_re_top', this.scroll_top)
      this.$router.push({name: 'MViewer', query: {file: this.$store.state.img_req_url + path}})
    },
    goTopicDetail(item) {
      if(item.news_arr && item.news_arr.length) {
        window.location.href = item.news_arr[0].src_url
      } else {
        const href = this.$store.state.index2_path + '/newsDetail/' + item.uid
        window.location.href = href
      }
    }
  },
  created() {
    this.getMeta()
  },
  mounted() {
    let _that = this
    window.onscroll = function () {
      _that.haddleScroll()
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '~mobile/styles/briefReport.stylus'
@import '~mobile/styles/newsletter.stylus'
</style>
